export enum DocumentType {
  PDF = '.pdf',
  HTML = '.html',
  EMAIL = '.eml',
  DEFAULT = '',
}
